module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "fm01"
    }
  }, [_c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "Epigraph"
  }, [_c('span', {
    staticClass: "Italics _idGenCharOverride-1"
  }, [_vm._v("In childhood, we gradually walk away from innocence and then spend the rest of our lives wanting to get back there.")])]), _vm._v(" "), _c('p', {
    staticClass: "Epigraph"
  }, [_vm._v("—Skipper Sanders in the summer of 2005")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "Epigraph"
  }, [_c('span', {
    staticClass: "Italics _idGenCharOverride-1"
  }, [_vm._v("Some are just visiting.")])]), _vm._v(" "), _c('p', {
    staticClass: "Epigraph"
  }, [_vm._v("—Joey Sanders in the fall of 2005")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eec8d92c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/05-fm01.vue
// module id = 69
// module chunks = 0